<template>
  <b-row>
    <b-col cols="5">
      <ContractSummary
        class="mt-2"
        :contract="contract"
        :contractCategories="contractCategories"/>
    </b-col>
    <b-col cols="7">
      <p
        class="text-muted mt-2">
        {{ infoText }}
      </p>
      <div class="d-flex flex-wrap cursorBcard">
        <div v-for="contactPerson in contactPersons"
               variant="transparent"
               class="p-0 my-2 mr-3 rounded-0 btn-estate-administration"
               :key="contactPerson.id"
               @click="onSelectContactPerson(contactPerson)">
          <BusinessCard
            class="rounded-0"
            size="sm"
            :name="contactPerson.firstName + ' ' + contactPerson.lastName"
            :relation="contactPerson.relation"
            :class="getPotClass(contactPerson)"
            :imageSrc="contactPerson.avatarUuid">
          </BusinessCard>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
  import BusinessCard from '@/components/common/BusinessCard'
  import ContractSummary from '@/components/contracts/ContractSummary'

  export default {
    name: 'ContractEstateDetails',
    components: {
      BusinessCard,
      ContractSummary
    },
    computed: {
      contract () {
        return this.$store.getters.currentContract
      },
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      },
      contactPersons () {
        return this.$store.getters.contactPersons
      },
      infoText () {
        if (this.contactPersons.length > 0) {
          return this.$t('message.contractEstateDetails.infoTextWithContactPersons')
        } else {
          return this.$t('message.contractEstateDetails.infoTextWithoutContactPersons')
        }
      }
    },
    methods: {
      getPotClass (pot) {
        if (this.contract.contactPerson && this.contract.contactPerson.id === pot.id) {
          return 'person-of-trust__selected'
        }
        return ''
      },
      onSelectContactPerson (contactPerson) {
        this.$store.commit('updateContactPerson', contactPerson)
      }
    }
  }
</script>

<style scoped>
  .person-of-trust__selected {
    background-color: rgba(0, 0, 0, .08);
    border: 2px solid #ccc;
  }
  .cursorBcard {
    cursor: pointer;
  }
  .btn-estate-administration:focus {
    box-shadow: none;
  }
</style>




// WEBPACK FOOTER //
// src/components/contracts/ContractEstateDetails.vue